import React from 'react';
import clsx from 'clsx';

import './OverlayLoader.scss';
import {IOverlayLoaderProps} from "./OverlayLoaderProps";


const OverlayLoader = (props: IOverlayLoaderProps) => {
	if (!props.show) return null;

	return (
		<div className={clsx('overlay-loader', props.className)} aria-live="polite" aria-busy="true">
			<div className="overlay-loader__backdrop" />
			<div className="overlay-loader__content">
				<div className="overlay-loader__spinner">
					<div /><div /><div /><div />
					<div /><div /><div /><div />
					<div /><div /><div /><div />
				</div>

				{Boolean(props.waitingText?.length) && (
					<p className="overlay-loader__text">{props.waitingText}</p>
				)}
			</div>
		</div>
	);
};
export default OverlayLoader;
